import { ROOT_DOMAIN_REGEX } from '../../constants';

export const getRootDomain = value =>
  value.replace(ROOT_DOMAIN_REGEX, '').replace(/[^a-zA-Z0-9-]/g, '');
